import React from 'react'

import { useVipRoute } from 'common/hooks/useVipRoute'

import { LabibaTrigger } from './LabibaTrigger/LabibaTrigger'
import { UserWayTrigger } from './UserWayTrigger/UserWayTrigger'
import styles from './ThirdPartyTools.module.scss'

export function ThirdPartyTools() {
  const { isVip: isVipRoute } = useVipRoute()

  return (
    <div className={isVipRoute ? styles.vipContainer : styles.container}>
      <UserWayTrigger />
      {!isVipRoute ? (
        <>
          <div className={styles.divider} />
          <LabibaTrigger />
        </>
      ) : null}
    </div>
  )
}
